import { Box, Stack, Text } from "@chakra-ui/react";

import DevsCard from "@/components/fichas/desarrollo/CardDevs";
import DevsCarousel from "@/components/fichas/desarrollo/CarouselDevs";
import useFormatter from "@/hooks/useFormatter";

export const DevelopsNear = ({
    code_dev,
    listDevs,
    session,
    saveDevFavorites,
    userFavorites,
    isCity = false,
}) => {
    const { NumberF } = useFormatter();
    const listDevsOrder = listDevs?.filter((dev) => dev.wiggot_code !== code_dev);
    return (
        <Box>
            <Text
                fontSize={{ md: "lg" }}
                ml={!isCity ? 0 : { base: "4vw", xl: "2vw" }}
                mt={!isCity ? 0 : "4vh"}
                color="#000000"
                fontWeight={!isCity ? 700 : 400}
            >
                {!isCity ? "Otros desarrollos que podrían interesarte" : null}
            </Text>
            <Stack w="full" align="center">
                <DevsCarousel gap={15} isMin={listDevsOrder.length < 3 ? true : false}>
                    {listDevsOrder?.map((item, idx) => {
                        return (
                            <DevsCard
                                isCentered={false}
                                key={idx}
                                id={item.wiggot_code}
                                title={item.name}
                                propertyType={
                                    item.tipo === "Departamento" || item.tipo === "Terreno"
                                        ? `${item.tipo}s`
                                        : item.tipo
                                }
                                subTitle={
                                    item?.min_presale ||
                                    item?.min_price ||
                                    item?.min_sale ||
                                    item?.min_lease
                                        ? `Desde ${NumberF(item?.min_presale && item?.min_presale !== "1" ? item?.min_presale : item?.min_price && item?.min_price !== "1" ? item?.min_price : item.min_sale ? item.min_sale : item.min_lease, true, "", 2)} MXN`
                                        : ""
                                }
                                imageUrl={
                                    item.photo
                                        ? item.photo
                                        : "https://media.grupoguia.mx/assets/home-page/fichas/nodisponible.webp"
                                }
                                link={`/desarrollo/${item.url_name}`}
                                buttonText="Ver más"
                                referred={true}
                                location={
                                    item.location_props?.name
                                        ? item.location_props?.name
                                        : (item.location_props.street_name
                                              ? item.location_props.street_name
                                              : "") +
                                          " " +
                                          (item.location_props.exterior_number
                                              ? item.location_props.exterior_number
                                              : "") +
                                          (item.location_props.city
                                              ? ", " + item.location_props.city
                                              : "") +
                                          (item.location_props.province
                                              ? ", " + item.location_props.province
                                              : "") +
                                          (item.location_props.country
                                              ? ", " + item.location_props.country
                                              : "")
                                }
                                groundSizeMin={
                                    item.product_props.min_construction_size > 0
                                        ? item.product_props.min_construction_size
                                        : item.product_props.min_ground_size
                                }
                                groundSizeMax={
                                    item.product_props.max_construction_size > 0
                                        ? item.product_props.max_construction_size
                                        : item.product_props.max_ground_size
                                }
                                bedroomsMin={item.product_props.min_bedrooms}
                                bedroomsMax={item.product_props.max_bedrooms}
                                industrial={false}
                                online_sale={item.online_sale_status === "ACTIVE" ? true : false}
                                operation_type={item?.operation_type}
                                session={session}
                                saveDevFavorites={saveDevFavorites}
                                development_id={item?.id}
                                userFavorites={userFavorites}
                                isDevelopmentSheet={isCity}
                            />
                        );
                    })}
                </DevsCarousel>
            </Stack>
        </Box>
    );
};

export default DevelopsNear;
